<template>
    <el-drawer
        title="取消众筹"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert type="warning" :title="`当前众筹: ${itemData && itemData.title}`" :closable="false"></el-alert>
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
                class="MT10"
            >
                 <el-form-item prop="remark" label="备注:">
                        <el-input
                            v-model="formData.remark"
                            placeholder="请输入备注"
                            :maxlength="100"
                            type="textarea"
                            :rows="4"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading: false,
            formData:{
                id:'',
                remark:''
            },
            itemData: null
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false
        },
        show(data){
            this.itemData = {...data};
            this.formData.id = data.id;
            this.drawerShow = true
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/raise/cancel',
                        method: 'POST',
                        params: this.formData
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.close();
                            setTimeout(() => {
                                this.$emit('onUpdate');
                            },800);
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.btnLoading = false;
                    });
                }else{
                    return false;
                }
            })    
        }
    }
}
</script>